module.exports = __webpack_public_path__ + "img/group.02db17e3.jpg";